import { MapId } from '../MapDefinition.ts';
import type { MapDefinition } from '../MapDefinition.ts';

export const GRAVEYARD_MAP: MapDefinition = {
  id: MapId.Graveyard,
  rows: [
    '################################',
    '#S....T...g.h.g....g.h.g..T...S#',
    '#..t......................t....#',
    '#...g.w.g...x......x...g.w.g...#',
    '#..........L........L..........#',
    '#..T..h.b..FFFF..FFFF..b.h..T..#',
    '#..........F..u..u..F..........#',
    '#S..g.d.g..F.C....C.F..g.d.g..S#',
    '#..........F........F..........#',
    '#..r.......FFF.==.FFF.......r..#',
    '#..............==..............#',
    '#=====f.....L..==..L.....f=====#',
    '#.............=PP=K............#',
    '#.............=PP=.............#',
    '#=====f.....L..==..L.....f=====#',
    '#..............==..............#',
    '#..r..g.h.g....==....g.h.g..r..#',
    '#S.........c..........c.......S#',
    '#..T..w.b.w..T....T..w.b.w..T..#',
    '#..........u..........u........#',
    '#...g.h.g.g...L..L...g.g.h.g...#',
    '#..t........................t..#',
    '#S.....T....h.g..g.h....T.....S#',
    '################################',
  ],
};
